import { render } from "./BoProfiles.vue?vue&type=template&id=6f281874&scoped=true&ts=true"
import script from "./BoProfiles.vue?vue&type=script&lang=ts"
export * from "./BoProfiles.vue?vue&type=script&lang=ts"

import "./BoProfiles.vue?vue&type=style&index=0&id=6f281874&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f281874"]])

export default __exports__